import { useEffect, useRef, useState } from "react";
import { LoadingShimmer, constants } from "@newsela/angelou";

const { ui } = constants.colors;

import {
  gradeLevelChartRowCss,
  gradeLevelChartCss,
  chartContainerCss,
  gradeLevelLabelCss,
  gradeLevelChartLoadingStateCss,
} from "./GradeLevelChartRow.style";

export interface GradeLevelChartRowProps {
  label: string;
  value: number;
  maxValue: number;
  isLoading: boolean;
}

const GradeLevelChartRow = ({
  label,
  value,
  maxValue,
  isLoading,
}: GradeLevelChartRowProps) => {
  const [labelIsDoubleLine, setLabelIsDoubleLine] = useState<boolean>(false);

  const labelRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    if (labelRef.current && labelRef.current.clientHeight > 25) {
      setLabelIsDoubleLine(true);
    } else {
      setLabelIsDoubleLine(false);
    }
  }, [labelRef?.current?.clientHeight]);

  return (
    <span css={gradeLevelChartRowCss}>
      <p ref={labelRef} css={gradeLevelLabelCss}>
        {label}
      </p>
      {isLoading ? (
        <LoadingShimmer
          backgroundColor={ui.core[100]}
          shimmerColor={ui.core[700]}
          __cssFor={{ root: gradeLevelChartLoadingStateCss(labelIsDoubleLine) }}
        />
      ) : (
        <span css={chartContainerCss}>
          <div css={gradeLevelChartCss(value, maxValue, labelIsDoubleLine)} />
          <p>{value}</p>
        </span>
      )}
    </span>
  );
};

export default GradeLevelChartRow;
